module.exports = __webpack_public_path__ + "static/media/growth.4b33eb35.png";